import {
    addParticipantToDatabase, deleteParticipantFromRegistrationFromDatabase, deleteRegistrationFromDatabase,
    fetchDistanceDataFromDatabase,
    fetchParticipantsByDistanceId,
    getAmountOfParticipantsInBoat
} from "./databasehandler";
import RegistrationRow from "../models/RegistrationRow";
import Distance from "../models/Distance";
import Gender from "../models/Gender";
import Category from "../models/Category";
import Boat from "../models/Boat";

export const getParticipantsByDistanceId = async (distanceId, clubId) => {
    const result = await fetchParticipantsByDistanceId(distanceId);
    if (result) {
        return result
            .filter(
                (reg) =>
                    reg.participant_id?.club_id === clubId ||
                    reg.participant_id2?.club_id === clubId ||
                    reg.participant_id3?.club_id === clubId ||
                    reg.participant_id4?.club_id === clubId
            )
            .map((row) => new RegistrationRow(row));
    }

    return null;
}

export const getDistanceData = async (eventId) => {
    const result = await fetchDistanceDataFromDatabase(eventId);
    if (result) {
        return result
            .map(
                (d) =>
                    new Distance(
                        d.id,
                        d.distance,
                        new Gender(d.Gender?.id, d.Gender?.gender),
                        new Category(d.Categories?.id, d.Categories?.category),
                        new Boat(d.Boat?.id, d.Boat?.boat, d.Boat?.amount_of_people)
                    )
            );
    }

    return null;
}

export const addParticipant = async (eventId, distanceId, participantId) => {
    const result = await addParticipantToDatabase(eventId, distanceId, participantId);
}

export const deleteParticipantById = async (registrationId, participantId, participantKey, distanceId) => {

    if (participantKey) {
        const result = await deleteParticipantFromRegistrationFromDatabase(registrationId, participantId, participantKey, distanceId);
        return;
    }

    const result = await deleteRegistrationFromDatabase(registrationId);
};
